// Notifications preferences strings — EN + TR.
//
// Wave-2 Day 1. Per-channel toggle preview (email / in-app / Slack-style
// external). Volkan direction 2026-05-23 (Settings 10-section expansion
// item #8).
//
// Surface-aware category sets per admin / seller / supply. Cross-ref
// i18n/shared/notification-bell.ts: bell event titles paralel ama daha
// detaylı; preferences sayfası daha geniş kategori (incidents / approval /
// wallet / order / WO). No duplicate text; preferences cluster categories,
// bell labels per-event.
//
// Source: features/settings/Notifications.tsx.

import type { LocalizedDict } from '../index'

type Channel = 'email' | 'in-app' | 'slack'

type NotificationsStrings = {
  pageTitle: string
  pageDescription: string
  footerNote: string
  toastTitle: string
  toastDescription: string
  columns: {
    category: string
  }
  channels: Record<Channel, string>
  categories: {
    platformIncidents: { label: string; description: string }
    approvalQueue: { label: string; description: string }
    walletSettlement: { label: string; description: string }
    orderEvents: { label: string; description: string }
    walletEvents: { label: string; description: string }
    integrationHealth: { label: string; description: string }
    workOrderEvents: { label: string; description: string }
    capacityEvents: { label: string; description: string }
  }
  real: {
    saveFailed: string
    keepOneChannel: string
    loading: string
    loadError: string
  }
}

export const notificationsI18n: LocalizedDict<NotificationsStrings> = {
  en: {
    pageTitle: 'Notifications',
    pageDescription:
      'Choose which categories alert you on each channel. Mock toggles — backend persistence M3 Stage 4 SPEC.md Faz 5.',
    footerNote:
      'Placeholder section · backend binding pending M3 Stage 4 SPEC.md Faz 5 (notifications engine ratify).',
    toastTitle: 'Preference toggled · mock-only',
    toastDescription:
      'Persistence ratifies M3 Stage 4 SPEC.md Faz 5 (notifications engine).',
    columns: {
      category: 'Category',
    },
    channels: {
      email: 'Email',
      'in-app': 'In-app',
      slack: 'Slack',
    },
    categories: {
      platformIncidents: {
        label: 'Platform incidents',
        description: 'Outages, queue stalls, integration sync failures.',
      },
      approvalQueue: {
        label: 'Approval queue updates',
        description:
          'Pending vendor updates, replacement workflows, B2B pushes.',
      },
      walletSettlement: {
        label: 'Wallet + settlement runs',
        description: 'Settlement results, refund flows, escrow events.',
      },
      orderEvents: {
        label: 'Order events',
        description: 'New orders, replacement requests, customer messages.',
      },
      walletEvents: {
        label: 'Wallet events',
        description: 'Credits, refunds, settlement summaries.',
      },
      integrationHealth: {
        label: 'Store integration health',
        description: 'Sync failures, auth expirations, listing rejections.',
      },
      workOrderEvents: {
        label: 'Work order events',
        description:
          'New work orders, urgent reroutes, due-date warnings.',
      },
      capacityEvents: {
        label: 'Capacity events',
        description: 'Capacity floor hit, escalation from admin.',
      },
    },
    real: {
      saveFailed: 'Could not save',
      keepOneChannel: 'Keep at least one channel on.',
      loading: 'Loading…',
      loadError: 'Could not load preferences.',
    },
  },
  tr: {
    pageTitle: 'Bildirimler',
    pageDescription:
      'Hangi kategorinin hangi kanaldan uyarı göndereceğini seç. Mock toggle — backend kalıcılığı M3 Stage 4 SPEC.md Faz 5.',
    footerNote:
      'Yer tutucu bölüm · backend bağlama M3 Stage 4 SPEC.md Faz 5 (bildirim motoru ratify) ile gelir.',
    toastTitle: 'Tercih değiştirildi · mock-only',
    toastDescription:
      'Kalıcı kayıt M3 Stage 4 SPEC.md Faz 5 (bildirim motoru) ile ratify.',
    columns: {
      category: 'Kategori',
    },
    channels: {
      email: 'E-posta',
      'in-app': 'Uygulama içi',
      slack: 'Slack',
    },
    categories: {
      platformIncidents: {
        label: 'Platform olayları',
        description:
          'Kesintiler, kuyruk takılmaları, entegrasyon senkron hataları.',
      },
      approvalQueue: {
        label: 'Onay kuyruğu güncellemeleri',
        description:
          'Bekleyen tedarikçi güncellemeleri, değişim akışları, B2B gönderim olayları.',
      },
      walletSettlement: {
        label: 'Cüzdan + settlement çalışmaları',
        description:
          'Settlement sonuçları, iade akışları, escrow olayları.',
      },
      orderEvents: {
        label: 'Sipariş olayları',
        description: 'Yeni siparişler, değişim talepleri, müşteri mesajları.',
      },
      walletEvents: {
        label: 'Cüzdan olayları',
        description: 'Krediler, iadeler, settlement özetleri.',
      },
      integrationHealth: {
        label: 'Mağaza entegrasyon sağlığı',
        description:
          'Senkron hataları, yetki süresi dolma, ilan reddleri.',
      },
      workOrderEvents: {
        label: 'İş emri olayları',
        description:
          'Yeni iş emirleri, acil yönlendirmeler, vade uyarıları.',
      },
      capacityEvents: {
        label: 'Kapasite olayları',
        description: 'Kapasite tabanı ihlali, admin yükseltmeleri.',
      },
    },
    real: {
      saveFailed: 'Kaydedilemedi',
      keepOneChannel: 'En az bir kanal açık kalmalı.',
      loading: 'Yükleniyor…',
      loadError: 'Tercihler yüklenemedi.',
    },
  },
}
